import { ProjectSuperTypeBase } from './base/project-super-type-base';

export class ProjectSuperType extends ProjectSuperTypeBase { }